<div [hidden]="!bulkUpdateInProgress" class="container">
    <div [hidden]="bulkUpdateCanceled">
        @if (!isBulkUpdateDone) {
            <h3 class="text-center">Bulk Updating {{ bulkUpdateEntityType }}s</h3>
        }
        @if (isBulkUpdateDone) {
            <h3 class="text-center">Done</h3>
        }
        <progressbar class="active"
                     [class.progress-striped]="bulkUpdateProgress.currentIndex < bulkUpdateProgress.selections.length"
                     [max]="bulkUpdateProgress.selections.length"
                     [value]="bulkUpdateProgress.currentIndex"
                     type="info"></progressbar>
        @if (!isBulkUpdateDone) {
            <h3>{{ getCurrentBulkUpdateIdentity() }}</h3>
        }
    </div>
    <div [hidden]="!bulkUpdateCanceled">
        <h3 class="text-center">Canceled</h3>
    </div>
    <div style="margin-top: 10px; font-size: 16px">
        <table class="bulk-update-results">
            @if (bulkUpdateProgress.missingTaxYearCount !== null) {
                <tr>
                    <td>
                        <label>Missing Parcel Tax Years:</label>
                    </td>
                    <td></td>
                    <td>{{ bulkUpdateProgress.missingTaxYearCount }}</td>
                </tr>
            }
            @if (bulkUpdateProgress.emptyAssessmentCount !== null) {
                <tr>
                    <td>
                        <label>Empty Parcel Assessments:</label>
                    </td>
                    <td></td>
                    <td>{{ bulkUpdateProgress.emptyAssessmentCount }}</td>
                </tr>
            }
            @if (bulkUpdateProgress.actualizedAssessmentCount !== null) {
                <tr>
                    <td>
                        <label>Actualized Parcel Assessments:</label>
                    </td>
                    <td></td>
                    <td>{{ bulkUpdateProgress.actualizedAssessmentCount }}</td>
                </tr>
            }
            @if (bulkUpdateProgress.parcelCount !== null) {
                <tr>
                    <td>
                        <label>Parcels Changed:</label>
                    </td>
                    <td></td>
                    <td>{{ bulkUpdateProgress.parcelCount }}</td>
                </tr>
            }
            @if (bulkUpdateProgress.siteCount !== null) {
                <tr>
                    <td>
                        <label>Sites Changed:</label>
                    </td>
                    <td></td>
                    <td>{{ bulkUpdateProgress.siteCount }}</td>
                </tr>
            }
            @if (bulkUpdateProgress.assessmentCount !== null) {
                <tr>
                    <td>
                        <label>Assessments Changed:</label>
                    </td>
                    <td></td>
                    <td>{{ bulkUpdateProgress.assessmentCount }}</td>
                </tr>
            }
            @if (bulkUpdateProgress.billCount !== null) {
                <tr>
                    <td>
                        <label>Bills Recalculated:</label>
                    </td>
                    <td></td>
                    <td>{{ bulkUpdateProgress.billCount }}</td>
                </tr>
            }
            @if (bulkUpdateProgress.paymentCount !== null) {
                <tr>
                    <td>
                        <label>Payments Recalculated:</label>
                    </td>
                    <td></td>
                    <td>{{ bulkUpdateProgress.paymentCount }}</td>
                </tr>
            }
            @if (bulkUpdateProgress.missingBudgetCount !== null) {
                <tr>
                    <td>
                        <label>Missing Budget Entries:</label>
                    </td>
                    <td></td>
                    <td>{{ bulkUpdateProgress.missingBudgetCount }}</td>
                </tr>
            }
            @if (bulkUpdateProgress.budgetFrozenCount !== null) {
                <tr>
                    <td>
                        <label>Budget Entries Frozen:</label>
                    </td>
                    <td></td>
                    <td>{{ bulkUpdateProgress.budgetFrozenCount }}</td>
                </tr>
            }
            @if (bulkUpdateProgress.budgetUnfrozenCount !== null) {
                <tr>
                    <td>
                        <label>Budget Entries Unfrozen:</label>
                    </td>
                    <td></td>
                    <td>{{ bulkUpdateProgress.budgetUnfrozenCount }}</td>
                </tr>
            }
            @if (bulkUpdateProgress.budgetCreatedCount !== null) {
                <tr>
                    <td>
                        <label>Budgets Entries Created:</label>
                    </td>
                    <td></td>
                    <td>{{ bulkUpdateProgress.budgetCreatedCount }}</td>
                </tr>
            }
            @if (bulkUpdateProgress.budgetSyncedCount !== null) {
                <tr>
                    <td>
                        <label>Budgets Entries Synced:</label>
                    </td>
                    <td></td>
                    <td>{{ bulkUpdateProgress.budgetSyncedCount }}</td>
                </tr>
            }
        </table>
    </div>
    <div class="text-center" style="margin-top: 20px;">
        @if (bulkUpdateCanceled || isBulkUpdateDone) {
            <button class="ace-btn btn-primary" (click)="endBulkUpdate()">OK</button>
        }
        @if (!bulkUpdateCanceled && !isBulkUpdateDone) {
            <button class="ace-btn btn-primary btn-danger" (click)="cancelBulkUpdate()">Cancel</button>
        }
    </div>
</div>